import Tag from './Tag';

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Tag/index.js